import { useCurrentUserQuery } from 'generated/graphql'

const useIsAdmin = () => {
  const { data } = useCurrentUserQuery()
  return data?.currentUser?.isSuperuser ?? false
}

export default useIsAdmin
